import { render } from "./AddNewClientService.vue?vue&type=template&id=600bb098&scoped=true"
import script from "./AddNewClientService.vue?vue&type=script&lang=js"
export * from "./AddNewClientService.vue?vue&type=script&lang=js"

import "./AddNewClientService.vue?vue&type=style&index=0&id=600bb098&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-600bb098"]])

export default __exports__